module.exports = __webpack_public_path__ + "img/camera.0bd2a800.svg";